import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const ProductConfig = lazyWithRetry(() => import(/* webpackChunkName: "product" */'../../component/Product/form/product'))

const ProductConfigPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<ProductConfig />
		</Suspense>
	)
})

ProductConfigPage.displayName = 'ProductConfigPage'
export default ProductConfigPage
